import { Component } from "react";
import {
    View,
    TouchableOpacity,
    Image,
    Dimensions,
    Pressable,
    ScrollView,
    Platform,
    Linking,
} from "react-native";

import { WHITE } from "react-native-material-color";
// import ActionSheet from 'react-native-actionsheet';

import * as Styles from "../utils/Styles";
import * as AppStyles from "../utils/appStyles";
import * as Commons from "../utils/Commons";
import { STRINGS } from "../utils/Strings";
import Text from "../components/Text";
import * as Animatable from "react-native-animatable";
import * as ServerOperations from "../utils/ServerOperations";
import loaderHandler from "../components/react-native-busy-indicator/LoaderHandler";
import InvoiceDetails from "./InvoiceDetails";
import ReturnsDetails from "./RetrurnsDetails";
import DateTimePicker from 'react-native-modal-datetime-picker';
let height = Dimensions.get("window").height;
let width = Commons.getWidth();
let styles = {};
let isMobile = false;
let scale = 1;
const InfoIcon = require("../images/StatementOfAccount/InfoIcon.png");
const imgCalender = require("../images/StatementOfAccount/calender.png");
const CloseIcon = require("../images/InvoiceDetails/closeIcon.png");
const imgDownloadIcon = require("../images/InvoiceDetails/downloadIcon.png");
const wFactor = 1; //width factor
const widths = [150 * wFactor, 150 * wFactor, 150 * wFactor, 150 * wFactor, 150 * wFactor, 150 * wFactor, 150 * wFactor];

class InvoicesReturns extends Component {
    constructor(props) {
        super(props);

        this.state = {
            SelectedButton: AppStyles.ButtonAfterPress,
            UnselectedButton: AppStyles.ButtonBeforePress,
            showInvoices: true,
            showReturns: false,
            showInvoicesReturns: false,
            showInvoiceDetails: false,
            showReturnsDetails: false,
            selectedFromDate: "",
            selectedToDate: "",
            fromDateStyle: AppStyles.dateTextStyle2,
            toDateStyle: AppStyles.dateTextStyle2,
            pickInvoices: [],
            pickReturns: [],
            invoiceID: '',
            invoiceDetails: [],
            invoiceDate: '',
            invoiceAmount: '',
            returnID: '',
            returnDate: '',
            returnAmount: '',
            returnDetails: [],
            invoiceTotal: '',
            returnTotal: '',
            showInvDetails: false,
            showRetDetails: false,
            InvOrRet: false,
            soaBalance: '',
            showInvoiceDesktop: false,
            showReturnDesktop: false,
            isOther: false,
            showFromDatePicker: false,
            showToDatePicker: false,

        };
    }
    Pressables = {};

    async componentDidMount() {
        if (!Commons.isMobile()) {
            const urlParams = new URLSearchParams(window.location.search);
            const type = urlParams.get('type');
            if (type === 'return') {
                this.setState({ showInvoicesReturns: true, showReturns: true, showInvoices: false });
            } else {
                this.setState({ showInvoicesReturns: true, showInvoices: true, showReturns: false });

            }
        }
        await this.loadData();
        const type = this.props.type;
        if (type === STRINGS.Desktop_Invoices) {
            this.setState({ showInvoiceDesktop: true, showReturnDesktop: false });
        } else {
            this.setState({ showInvoiceDesktop: false, showReturnDesktop: true });
        }
        // if (ScreenType == 'invoices') {
        //     this.setState({ showInvoiceDesktop: true, showReturnDesktop: false });
        // }

        if (typeof window !== 'undefined' && window.addEventListener) {
            window.addEventListener('popstate', this.handleBackButton);

            // Push current state to history for better navigation
            const currentState = {
                page: 'InvoicesAndReturns',
                timestamp: Date.now()
            };
            window.history.pushState(currentState, 'InvoicesAndReturns', window.location.pathname);
        }
    }

    componentWillUnmount() {
        // Clean up event listener
        if (typeof window !== 'undefined' && window.removeEventListener) {
            window.removeEventListener('popstate', this.handleBackButton);
        }
    }

    handleBackButton = (event) => {
        // Handle back button press - close product details
        this.setState({ showInvoiceDetails: false, showReturnsDetails: false });

        // Prevent default browser back behavior if needed
        // You can remove this if you want normal browser back behavior
        if (event.state && event.state.page === 'InvoicesAndReturns') {
            // Custom handling - stay on current page but close modal/details
            window.history.pushState(event.state, 'InvoicesAndReturns', window.location.pathname);
        }
    }


    loadData = async () => {
        loaderHandler.showLoader(STRINGS.loading, this);
        let resp = await ServerOperations.getInvoices(this.state.selectedFromDate, this.state.selectedToDate, '');
        this.setState({ selectedFromDate: resp.FROM_DATE, selectedToDate: resp.TO_DATE, pickInvoices: resp.INVS, invoiceTotal: resp.TOTAL });
        resp = await ServerOperations.getReturns(this.state.selectedFromDate, this.state.selectedToDate, '');
        this.setState({ pickReturns: resp.INVS, returnTotal: resp.TOTAL });
        loaderHandler.hideLoader();
    }


    renderReturnsDetails = () => {
        const returnDetails = this.state.returnDetails.map((returns) => (
            <View style={[AppStyles.InvoiceDetailsMainViewStyle, { width: width - 40, paddingHorizontal: 26 }]}>
                <View style={{ alignItems: 'center', gap: 24, flexDirection: 'row', width: width - 40 }}>
                    <View style={{ flexDirection: 'column', gap: 6, marginTop: 15 }}>
                        <Text style={[AppStyles.InvoiceDetailsItemsStyle]}>Item</Text>
                        {Commons.getTextWidth(returns.ITEM_CODE) > (width - 180) && <Text style={[[AppStyles.InvoiceDetailsItemsStyle]]}>  </Text>}
                        <Text style={[AppStyles.InvoiceDetailsItemsStyle]}>Qty</Text>
                        <Text style={[AppStyles.InvoiceDetailsItemsStyle]}>Price</Text>
                        <Text style={[AppStyles.InvoiceDetailsItemsStyle]}>Expiry</Text>
                        <Text style={[AppStyles.InvoiceDetailsItemsStyle]}>Batch</Text>
                    </View>
                    <View style={{ flexDirection: 'column', gap: 6, marginTop: 15 }}>
                        <Text style={[AppStyles.InvoiceDetailsItemsStyle, { fontWeight: '400', maxWidth: width - 130 }]}>{returns.ITEM_CODE}</Text>
                        <Text style={[AppStyles.InvoiceDetailsItemsStyle, { fontWeight: '400' }]}>{returns.QTY}</Text>
                        <Text style={[AppStyles.InvoiceDetailsItemsStyle, { fontWeight: '400' }]}>{returns.PRICE}</Text>
                        <Text style={[AppStyles.InvoiceDetailsItemsStyle, { fontWeight: '400' }]}>{returns.EXP_DATE}</Text>
                        <Text style={[AppStyles.InvoiceDetailsItemsStyle, { fontWeight: '400' }]}>{returns.BATCH}</Text>
                    </View>
                    <View style={{ position: 'absolute', right: 32, flexDirection: 'column', alignItems: 'flex-start', gap: 5, marginTop: 80, width: 100 }}>
                        {returns.DISCOUNT > 0 ? <Text style={[AppStyles.InvoiceDetailsItemsStyle, { fontSize: 10.751 }]}>{STRINGS.discount_2} {returns.DISCOUNT}</Text> : <Text></Text>}
                        <Text style={[AppStyles.InvoiceDetailsItemsStyle, { fontSize: 10.751 }]}>{STRINGS.Tax_invoice} {returns.TAX}</Text>
                        <Text style={[AppStyles.InvoiceDetailsItemsStyle, { fontSize: 10.751 }]}>{STRINGS.Total_invoice} {returns.TOTAL}</Text>
                    </View>
                </View>
                <Text></Text>
            </View>
        ));
        return (
            <Animatable.View
                animation="slideInUp"
                duration={500}
                style={{
                    flex: 1,
                    position: 'absolute',
                    top: '0%',
                    transform: [{ translateX: -(width - 20) / 2 }, { translateY: -237.5 }],
                    zIndex: 1000,
                    flexDirection: 'column',
                    backgroundColor: 'white',
                    alignItems: 'center',
                    height,
                    width
                }}>
                {this.renderHeaderDialog()}
                <View style={{ width: width - 40, flexDirection: 'column', alignItems: 'flex-start', gap: 8, paddingHorizontal: 20 }}>
                    <Text style={[AppStyles.H2Styles, { alignSelf: 'stretch' }]}>{STRINGS.Return_Details}</Text>
                    <View style={{ justifyContent: 'space-between', alignItems: 'center', alignSelf: 'stretch', flexDirection: 'row' }}>
                        <View style={{ flexDirection: 'column', gap: 5 }}>
                            <Text style={[AppStyles.H3Styles, { height: 23.943, alignSelf: 'stretch' }]}>{this.state.returnID}</Text>
                            <Text style={[AppStyles.BodyTextStyles, { color: 'rgba(59, 98, 127, 0.50)', alignSelf: 'stretch' }]}>{this.state.returnDate}</Text>
                        </View>
                        <View>
                            <Text style={[AppStyles.BodyTextStyles, {}]}>
                                {this.state.returnAmount}{' '}
                                <Text style={[AppStyles.JODinvoiceStyle, {}]}>
                                    JOD
                                </Text>
                            </Text>
                        </View>
                    </View>
                </View>
                <ScrollView style={{ marginTop: 32, gap: 32, flexDirection: 'column', minHeight: height - 200 }} showsVerticalScrollIndicator={false}>
                    {returnDetails}
                    <Text style={{ height: 56 }}></Text>
                </ScrollView>
                {/* {this.renderDownloadButton('return')} */}
            </Animatable.View>
        )
    }



    renderInvoiceDetails = () => {
        var tabletHeight = undefined;
        if (height > 500) { tabletHeight = 1200; }
        const InvoicesDetails = this.state.invoiceDetails.map((invoice) => (
            <View style={[AppStyles.InvoiceDetailsMainViewStyle, { width: width - 40, paddingHorizontal: 26 }]}>
                <View style={{ alignItems: 'center', gap: 24, flexDirection: 'row', width: width - 40 }}>
                    <View style={{ flexDirection: 'column', gap: 6, marginTop: 15 }}>
                        <Text style={[AppStyles.InvoiceDetailsItemsStyle]}>Item</Text>
                        {Commons.getTextWidth(invoice.ITEM_CODE) > (width - 180) && <Text style={[[AppStyles.InvoiceDetailsItemsStyle]]}>  </Text>}
                        <Text style={[AppStyles.InvoiceDetailsItemsStyle]}>Qty</Text>
                        <Text style={[AppStyles.InvoiceDetailsItemsStyle]}>Price</Text>
                        <Text style={[AppStyles.InvoiceDetailsItemsStyle]}>Expiry</Text>
                        <Text style={[AppStyles.InvoiceDetailsItemsStyle]}>Batch</Text>
                    </View>
                    <View style={{ flexDirection: 'column', gap: 6, marginTop: 15 }}>
                        <Text style={[AppStyles.InvoiceDetailsItemsStyle, { fontWeight: '400', maxWidth: width - 130 }]}>{invoice.ITEM_CODE}</Text>
                        <Text style={[AppStyles.InvoiceDetailsItemsStyle, { fontWeight: '400' }]}>{invoice.QTY}</Text>
                        <Text style={[AppStyles.InvoiceDetailsItemsStyle, { fontWeight: '400' }]}>{invoice.PRICE}</Text>
                        <Text style={[AppStyles.InvoiceDetailsItemsStyle, { fontWeight: '400' }]}>{invoice.EXP_DATE}</Text>
                        <Text style={[AppStyles.InvoiceDetailsItemsStyle, { fontWeight: '400' }]}>{invoice.BATCH}</Text>
                    </View>
                    <View style={{ position: 'absolute', right: 32, flexDirection: 'column', alignItems: 'flex-start', gap: 5, marginTop: 80, width: 100 }}>
                        {invoice.DISCOUNT > 0 ? <Text style={[AppStyles.InvoiceDetailsItemsStyle, { fontSize: 10.751 }]}>{STRINGS.discount_2} {invoice.DISCOUNT}</Text> : <Text></Text>}
                        <Text style={[AppStyles.InvoiceDetailsItemsStyle, { fontSize: 10.751 }]}>{STRINGS.Tax_invoice} {invoice.TAX}</Text>
                        <Text style={[AppStyles.InvoiceDetailsItemsStyle, { fontSize: 10.751 }]}>{STRINGS.Total_invoice} {invoice.TOTAL}</Text>
                    </View>
                </View>
                <Text></Text>
            </View>
        ));
        return (
            <Animatable.View
                animation="slideInUp"
                duration={500}
                style={{
                    flex: 1,
                    position: 'absolute',
                    top: '0%',
                    transform: [{ translateX: -(width - 20) / 2 }, { translateY: -237.5 }],
                    zIndex: 1000,
                    flexDirection: 'column',
                    backgroundColor: 'white',
                    alignItems: 'center',
                    height,
                    width
                }}>
                {this.renderHeaderDialog()}
                <View style={{ width: width - 40, flexDirection: 'column', alignItems: 'flex-start', gap: 8, paddingHorizontal: 20 }}>
                    <Text style={[AppStyles.H2Styles, { alignSelf: 'stretch' }]}>{STRINGS.Invoice_Details}</Text>
                    <View style={{ justifyContent: 'space-between', alignItems: 'center', alignSelf: 'stretch', flexDirection: 'row' }}>
                        <View style={{ flexDirection: 'column', gap: 5 }}>
                            <Text style={[AppStyles.H3Styles, { height: 23.943, alignSelf: 'stretch' }]}>{this.state.invoiceID}</Text>
                            <Text style={[AppStyles.BodyTextStyles, { color: 'rgba(59, 98, 127, 0.50)', alignSelf: 'stretch' }]}>{this.state.invoiceDate}</Text>
                        </View>
                        <View>
                            <Text style={[AppStyles.BodyTextStyles, {}]}>
                                {this.state.invoiceAmount}{' '}
                                <Text style={[AppStyles.JODinvoiceStyle, {}]}>
                                    JOD
                                </Text>
                            </Text>
                        </View>
                    </View>
                </View>
                <ScrollView style={{ marginTop: 32, gap: 32, flexDirection: 'column' }} showsVerticalScrollIndicator={false}>
                    {InvoicesDetails}
                    <Text style={{ height: 56 }}></Text>
                </ScrollView>
                {this.state.invoiceURL && this.renderDownloadButton()}

            </Animatable.View>
        )
    }

    renderHeaderDialog = () => {
        return (
            <View style={{ flexDirection: 'row', alignItems: 'center', padding: 20, alignSelf: "stretch", justifyContent: "space-between", height: 75, width }}>
                <TouchableOpacity>
                    {/* <Image source={CloseIcon} style={{width: 14, height: 14}} /> */}
                </TouchableOpacity>
                <TouchableOpacity onPress={() => {
                    this.setState({ showInvoiceDetails: false, showReturnsDetails: false })
                }}
                    style={{ marginRight: 6 }}>
                    <Image source={CloseIcon} style={{ width: 14, height: 14 }} />
                </TouchableOpacity>
            </View>
        )
    }

    renderHeaderMobile = () => {
        return (
            <View style={{ flexDirection: 'row', alignItems: 'center', padding: 20, alignSelf: "stretch", justifyContent: "space-between" }}>
                {/* <TouchableOpacity onPress={() => window.history.back()}>
                    <Image source={imgJdsLogo} style={{
                        width: 35.063,
                        height: 37,
                        padding: 1,
                        resizeMode: "contain",
                    }} />
                </TouchableOpacity> */}
                <View></View>
                <Text style={[AppStyles.H2Styles]}>{STRINGS.Invoices_Returns}</Text>
                <View></View>
                {/* <TouchableOpacity onPress={() => window.location = './profile'}>
                    <Image source={imgProfile} style={{ width: 20, height: 20, stroke: Styles.appColor1 }}></Image>
                </TouchableOpacity> */}
            </View>
        )
    }

    renderDownloadButton = () => {
        return (
            <TouchableOpacity style={{
                width: 53, height: 56,
                justifyContent: 'center', alignItems: 'center',
                borderRadius: 50, backgroundColor: '#92D8F5',
                boxShadow: '0px 2px 2px 0px rgba(0, 0, 0, 0.15)', position: 'absolute', bottom: 20, right: 20,
            }}
                onPress={() => Linking.openURL(this.state.invoiceURL)}>
                <Image source={imgDownloadIcon} style={{ width: 56, height: 56, marginTop: 4 }} />
            </TouchableOpacity>
        )
    }


    renderMobile() {
        scale = width / 420;
        var paddingHorz = 20;
        if (this.state.showInvoiceDetails == true) { paddingHorz = undefined }
        if (this.state.showReturnsDetails == true) { paddingHorz = undefined }
        return (
            <View style={styles.container}>
                {this.state.showInvoiceDetails == false && this.state.showReturnsDetails == false && this.renderHeaderMobile()}
                {/* {this.state.showInvoiceDetails == true && this.renderHeaderDialog()}
                {this.state.showReturnsDetails == true && this.renderHeaderDialog()} */}
                {this.state.showInvoiceDetails == true && this.renderInvoiceDetails()}
                {this.state.showReturnsDetails == true && this.renderReturnsDetails()}
                <ScrollView
                    ref={ref => this.mainScrollView = ref}
                    scrollEventThrottle={200} showsVerticalScrollIndicator={false} onScroll={(e) => Commons.onHeaderScroll(e, this)}>
                    <View style={{ width, paddingHorizontal: paddingHorz }}>
                        {Commons.loadFonts(this, false)}
                        {Styles.renderVSeparator(0)}
                        {this.renderPart1Mobile()}
                        {this.state.showInvoicesReturns == true && this.renderPart2Mobile()}
                        {this.state.showInvoices == true && this.state.showInvoicesReturns == true && this.renderInvoicesMobile()}
                        {this.state.showReturns == true && this.renderReturnsMobile()}
                    </View>
                </ScrollView>
                {this.state.isOther && Commons.renderOtherView(this, this.state.isOther)}
                {Commons.renderAppFooter({}, this, '', '', '', '#52C0EE')}
                <DateTimePicker
                    mode="date"
                    isVisible={this.state.showFromDatePicker}
                    onConfirm={(date) => {
                        this.setState({ selectedFromDate: date.toISOString().split('T')[0], showFromDatePicker: false });
                    }}
                    onCancel={() => this.setState({ showFromDatePicker: false })}
                />
                <DateTimePicker
                    mode="date"
                    isVisible={this.state.showToDatePicker}
                    onConfirm={(date) => {
                        this.setState({ selectedToDate: date.toISOString().split('T')[0], showToDatePicker: false });
                    }}
                    onCancel={() => this.setState({ showToDatePicker: false })}
                />
            </View >
        );
    }

    render() {
        width = Dimensions.get("window").width;
        isMobile = Commons.isMobile();
        if (isMobile) {
            Commons.resizeHandle(window, this, () => {
                width = this.width;
                height = this.height;
            });
            styles = this.styles();
            return this.renderMobile();
        }


        if (!this.props.self) {
            window.location = './ClientHomePage?tab=' + STRINGS.Invoices_Returns;
            return;
        } else {
            this.props.self.currentComponent = this;
        }

        scale = width / 1440;
        if (scale > 1) scale = 1;
        width = Commons.getDesktopWidth();
        height = Commons.getDesktopHeight();
        styles = this.styles();
        return (
            <View style={styles.container}>
                <View style={{ flex: 1, flexDirection: 'row', gap: 20, backgroundColor: AppStyles.desktopBackgroundColor, height: '100%', width: '100%' }}>
                    <View style={{ flex: 1, flexDirection: 'row', gap: 20, backgroundColor: AppStyles.desktopBackgroundColor, height, width }}>
                        {this.state.showInvoiceDesktop && this.state.showInvDetails == false && this.renderInvoices()}
                        {this.state.showReturnDesktop && this.state.showRetDetails == false && this.renderReturns()}
                        {/* {this.state.showInvDetails && this.renderInvoiceDetails()} */}
                        {this.state.showInvDetails &&
                            <InvoiceDetails
                                InvoiceNumber={this.state.InvNo}
                                InvoiceDate={this.state.InvDate}
                                InvoiceAmount={this.state.InvValue}
                                InvoiceID={this.state.InvID}
                                showInvoiceDetails={(show) => { this.setState({ showInvDetails: show, InvOrRet: show }); this.props.self.setState({ style: { opacity: 1 } }) }}
                            />
                        }
                        {this.state.showRetDetails &&
                            <ReturnsDetails
                                RetNumber={this.state.RetNo}
                                RetDate={this.state.RetDate}
                                RetAmount={this.state.RetValue}
                                RetID={this.state.RetID}
                                showRetDetails={(show) => { this.setState({ showRetDetails: show, InvOrRet: show }); this.props.self.setState({ style: { opacity: 1 } }) }}
                            />
                        }
                    </View>
                </View>

            </View>
        );
    }


    renderPart1 = () => {
    }

    renderPart1Mobile = () => {
        return (
            <View style={{ width: width - 40, marginTop: 30, flexDirection: 'column', gap: 30 }}>
                <View style={{ width: width - 40, justifyContent: 'center', alignItems: 'center', gap: 7, flexDirection: 'row' }}>
                    <TouchableOpacity
                        onPress={() => {
                            if (Platform.OS === 'web') {
                                this.fromDateInput.showPicker();
                            } else {
                                this.setState({ showFromDatePicker: true });
                            }
                        }}
                        style={{
                            height: 40, flexDirection: 'row', width: '48%', justifyContent: 'space-between',
                            alignItems: 'center', borderRadius: 10, borderWidth: 1, borderColor: 'rgba(59, 98, 127, 0.50)'
                        }}>
                        <Text style={[AppStyles.FromToDateTextStyle, { position: 'absolute', top: -10, left: 10, backgroundColor: AppStyles.desktopBackgroundColor, width: 35 }]}>{STRINGS.from}</Text>
                        <Text style={[this.state.fromDateStyle, { paddingHorizontal: 10 }]}>{this.state.selectedFromDate}</Text>
                        <Image source={imgCalender} style={{ width: 17, height: 17, marginRight: 10 }} />
                        {Platform.OS === 'web' && (
                            <input
                                ref={e => this.fromDateInput = e}
                                type="date"
                                value={this.state.selectedFromDate}
                                onChange={(e) => this.setState({ selectedFromDate: e.target.value, fromDateStyle: AppStyles.dateTextStyle2, showInvoicesReturns: false, showReturns: false, showInvoices: false })}
                                style={{ position: 'absolute', top: 0, left: 0, opacity: 0, width: '100%', height: '100%' }}

                            />
                        )}
                    </TouchableOpacity>

                    <TouchableOpacity
                        onPress={() => {
                            if (Platform.OS === 'web') {
                                this.toDateInput.showPicker();
                            } else {
                                this.setState({ showToDatePicker: true });
                            }
                        }}
                        style={{ height: 40, flexDirection: 'row', width: '48%', justifyContent: 'space-between', alignItems: 'center', borderRadius: 10, borderWidth: 1, borderColor: 'rgba(59, 98, 127, 0.50)', }}>
                        <Text style={[AppStyles.FromToDateTextStyle, { position: 'absolute', top: -10, left: 10, backgroundColor: AppStyles.desktopBackgroundColor, width: 20 }]}>{STRINGS.to}</Text>
                        <Text style={[this.state.toDateStyle, { paddingHorizontal: 10 }]}>{this.state.selectedToDate}</Text>
                        <Image source={imgCalender} style={{ width: 17, height: 17, marginRight: 10 }} />
                        {Platform.OS === 'web' && (
                            <input
                                ref={e => this.toDateInput = e}
                                type="date"
                                value={this.state.selectedFromDate}
                                onChange={(e) => this.setState({ selectedToDate: e.target.value, toDateStyle: AppStyles.dateTextStyle2, showInvoicesReturns: false, showReturns: false, showInvoices: false })}
                                style={{ position: 'absolute', top: 0, left: 0, opacity: 0, width: '100%', height: '100%' }}
                            />
                        )}
                    </TouchableOpacity>
                </View>
                {this.state.showInvoicesReturns == false && (
                    <TouchableOpacity style={AppStyles.loginButtonStyles}
                        onPress={async () => {
                            loaderHandler.showLoader(STRINGS.loading, this);
                            await this.loadData();
                            this.setState({
                                showInvoicesReturns: true, showInvoices: true,
                                showReturns: false,
                                SelectedButton: AppStyles.ButtonAfterPress,
                                UnselectedButton: AppStyles.ButtonBeforePress,
                                showInvoices: true,
                                showReturns: false,
                            });
                        }}>
                        <Text style={AppStyles.loginButtonTextStyles}>{STRINGS.Request}</Text>
                    </TouchableOpacity>
                )}
            </View>
        )
    }


    renderPart2 = () => {

    }

    renderPart2Mobile = () => {
        var textMargin = undefined;
        if (this.state.showInvoices == true) { textMargin = 2 }
        return (
            <View style={{ width: width - 40, flexDirection: 'column', alignItems: 'flex-start', marginTop: 36 }}>
                <View style={{ flexDirection: 'row', gap: 5, borderRadius: 14, backgroundColor: 'rgba(37, 89, 126, 0.10)', alignSelf: 'stretch', height: 40, justifyContent: 'center', alignItems: 'center' }}>
                    <TouchableOpacity style={[this.state.SelectedButton]}
                        onPress={() => this.setState({
                            SelectedButton: AppStyles.ButtonAfterPress,
                            UnselectedButton: AppStyles.ButtonBeforePress,
                            showInvoices: true,
                            showReturns: false,
                        })}
                    >
                        <Text style={[AppStyles.BodyTextStyles, { marginHorizontal: textMargin }]}>{STRINGS.Invoices}</Text>
                    </TouchableOpacity>
                    <TouchableOpacity style={[this.state.UnselectedButton]}
                        onPress={() => this.setState({
                            SelectedButton: AppStyles.ButtonBeforePress,
                            UnselectedButton: AppStyles.ButtonAfterPress,
                            showInvoices: false,
                            showReturns: true,
                        })}>
                        <Text style={[AppStyles.BodyTextStyles]}>{STRINGS.Returns}</Text>
                    </TouchableOpacity>
                </View>

                <View style={{ flexDirection: 'column', alignItems: 'center', gap: 16, alignSelf: 'stretch', borderRadius: 4, backgroundColor: '#FFF', boxShadow: '0px 2px 6px 0px rgba(0, 0, 0, 0.08)', marginTop: 50 }}>
                    <View style={{ flexDirection: 'column', gap: 16, alignItems: 'center', marginTop: 32 }}>
                        <Text style={[AppStyles.H3Styles, { textAlign: 'center' }]}>{STRINGS.Total_Amount}</Text>
                        <Text style={[AppStyles.DueBalanceNumStyle, { paddingHorizontal: 32 }]}>
                            {this.state.showInvoices == true && this.state.invoiceTotal}
                            {this.state.showReturns == true && this.state.returnTotal}
                            <Text style={[AppStyles.DueBalanceTextStyle, {}]}>
                                JOD
                            </Text>
                        </Text>
                        <Text style={{ height: 28 }}></Text>
                    </View>
                </View>
            </View>
        );
    }


    loadInvoices = async () => {
        loaderHandler.showLoader(STRINGS.loading, this);
        const resp = await ServerOperations.getInvoices(this.state.selectedFromDate, this.state.selectedToDate, '');
        console.log(resp)
        const invData = resp.INVS.map((item) => {
            return (
                <Pressable style={{ width: 912 * scale }}>
                    <TouchableOpacity style={{
                        flexDirection: 'row',
                        marginTop: 20,
                        height: 50, borderBottomColor: 'rgba(0, 0, 0, 0.16)',
                        borderBottomWidth: 1.5, justifyContent: 'space-between',
                        width: 912 * scale,
                    }}
                        onPress={() => {
                            this.setState({
                                InvNo: item.ID,
                                InvID: item.INV_ID, InvDate: item.DATE,
                                InvValue: item.VALUE, showInvDetails: true, InvOrRet: true
                            });
                        }}>
                        <Text style={[AppStyles.BodyTextInvDetailsStyles, { width: widths[0] * scale }]}>{item.ID}</Text>
                        <Text style={[AppStyles.BodyTextInvDetailsStyles, { width: widths[1] * scale }]}>{item.DATE}</Text>
                        <Text style={[AppStyles.BodyTextInvDetailsStyles, { width: widths[2] * scale }]}>{item.VALUE}</Text>
                    </TouchableOpacity>
                </Pressable>
            )
        });
        this.setState({ selectedFromDate: resp.FROM_DATE, selectedToDate: resp.TO_DATE, Invoices: invData, invoiceTotal: resp.TOTAL });
    }

    loadReturns = async () => {
        const resp = await ServerOperations.getReturns(this.state.selectedFromDate, this.state.selectedToDate, '');
        const returnsData = resp.INVS.map((item) => {
            return (
                <TouchableOpacity style={{
                    flexDirection: 'row',
                    marginTop: 20,
                    height: 50, borderBottomColor: 'rgba(0, 0, 0, 0.16)',
                    borderBottomWidth: 1.5, justifyContent: 'space-between',
                    width: 912 * scale,
                }}
                    onPress={() => {
                        this.setState({
                            RetNo: item.ID, RetDate: item.DATE, RetID: item.INV_ID,
                            RetValue: item.VALUE, showRetDetails: true, InvOrRet: true
                        });
                    }}>
                    <Text style={[AppStyles.BodyTextInvDetailsStyles, { width: widths[0] * scale }]}>{item.ID}</Text>
                    <Text style={[AppStyles.BodyTextInvDetailsStyles, { width: widths[1] * scale }]}>{item.DATE}</Text>
                    <Text style={[AppStyles.BodyTextInvDetailsStyles, { width: widths[2] * scale }]}>{item.VALUE}</Text>
                </TouchableOpacity>
            )
        });
        this.setState({ selectedFromDate: resp.FROM_DATE, selectedToDate: resp.TO_DATE, Returns: returnsData, ReturnTotal: resp.TOTAL });
    }

    renderRequestButton = () => {
        return (
            <TouchableOpacity style={[AppStyles.primaryButtonStyle, { width: 109 }]}
                onPress={async () => {
                    loaderHandler.showLoader(STRINGS.loading, this.props.self);
                    if (this.state.showInvoiceDesktop) { await this.loadInvoices(); this.setState({ flag: 1 }) }
                    if (this.state.showReturnDesktop) { await this.loadReturns(); this.setState({ flag: 1 }) }
                    loaderHandler.hideLoader();
                }}>
                <Text style={AppStyles.loginButtonTextStyles}>{STRINGS.Request}</Text>
            </TouchableOpacity>
        )
    }

    renderInvoices = () => {
        const InvoicesHeaders = [
            { title: STRINGS.Desktop_invoice_number, margHorz: 18 },
            { title: STRINGS.Date_desktop_date, margHorz: undefined },
            { title: STRINGS.Desktop_Total, margHorz: undefined },
        ];
        return (
            <View style={{ flexDirection: 'column', alignItems: 'flex-start', }}>
                <Text style={[AppStyles.H2Styles, { marginLeft: 50, marginTop: 80 }]}>{STRINGS.Invoices}</Text>
                <View style={{ flexDirection: 'row', gap: 10, marginHorizontal: 50, marginTop: 32 }}>
                    {this.renderDateSelection()}
                    {this.renderRequestButton('invoices')}
                </View>

                {this.state.flag == 1 && (
                    <View style={{
                        paddingHorizontal: 40, marginTop: 20, backgroundColor: 'white',
                        borderRadius: 16, paddingBottom: 20,
                        marginLeft: 50,
                        marginTop: 50,
                    }}>
                        <View style={{
                            borderTopRightRadius: 16, borderTopLeftRadius: 16,
                            paddingVertical: 20, flexDirection: 'row', justifyContent: 'space-between',
                            borderBottomColor: 'rgba(0, 0, 0, 0.16)',
                            borderBottomWidth: 1.5,
                            width: 912 * scale,
                        }}>
                            {InvoicesHeaders.map((header, index) => {
                                return (
                                    <View style={{
                                        alignItems: 'center',
                                        justifyContent: 'space-between',
                                    }}>
                                        <Text style={[AppStyles.tblHeaderStyle, { width: widths[index] * scale }]}>{header.title}</Text>
                                    </View>
                                )
                            })}
                        </View>
                        <ScrollView style={{ height: height - 350, maxHeight: 600 }} >
                            {this.state.Invoices}
                        </ScrollView>
                    </View>
                )
                }
            </View>
        )
    }

    renderDateSelection = () => {
        return (
            <View style={{ justifyContent: 'flex-start', alignItems: 'center', gap: 7, flexDirection: 'row' }}>

                <TouchableOpacity
                    onPress={() => {
                        if (Platform.OS === 'web') {
                            this.fromDateInput.showPicker();
                        } else {
                            this.setState({ showFromDatePicker: true });
                        }
                    }}
                    style={{
                        height: 42, flexDirection: 'row', width: 265, justifyContent: 'space-between',
                        alignItems: 'center', borderRadius: 10, borderWidth: 1, borderColor: 'rgba(59, 98, 127, 0.50)',
                    }}>
                    <Text style={[AppStyles.FromToDateTextStyle, { position: 'absolute', top: -10, left: 10, backgroundColor: AppStyles.desktopBackgroundColor, width: 35 }]}>{STRINGS.from}</Text>
                    <Text style={[AppStyles.dateTextStyle2, { paddingHorizontal: 10 }]}>{this.state.selectedFromDate}</Text>
                    <Image source={imgCalender} style={{ width: 17, height: 17, marginRight: 10 }} />
                    {Platform.OS === 'web' && (
                        <input
                            ref={e => this.fromDateInput = e}
                            type="date"
                            value={this.state.selectedFromDate}
                            onChange={(e) => this.setState({ selectedFromDate: e.target.value, })}
                            style={{ position: 'absolute', top: 0, left: 0, opacity: 0, width: '100%', height: '100%' }}

                        />
                    )}
                </TouchableOpacity>

                <TouchableOpacity
                    onPress={() => {
                        if (Platform.OS === 'web') {
                            this.toDateInput.showPicker();
                        } else {
                            this.setState({ showToDatePicker: true });
                        }
                    }}
                    style={{ height: 42, flexDirection: 'row', width: 265, justifyContent: 'space-between', alignItems: 'center', borderRadius: 10, borderWidth: 1, borderColor: 'rgba(59, 98, 127, 0.50)' }}>
                    <Text style={[AppStyles.FromToDateTextStyle, { position: 'absolute', top: -10, left: 10, backgroundColor: AppStyles.desktopBackgroundColor, width: 20 }]}>{STRINGS.to}</Text>
                    <Text style={[AppStyles.dateTextStyle2, { paddingHorizontal: 10 }]}>{this.state.selectedToDate}</Text>
                    <Image source={imgCalender} style={{ width: 17, height: 17, marginRight: 10 }} />
                    {Platform.OS === 'web' && (
                        <input
                            ref={e => this.toDateInput = e}
                            type="date"
                            value={this.state.selectedToDate}
                            onChange={(e) => this.setState({ selectedToDate: e.target.value, })}
                            style={{ position: 'absolute', top: 0, left: 0, opacity: 0, width: '100%', height: '100%' }}
                        />
                    )}
                </TouchableOpacity>
            </View>
        )
    }

    loadInvoiceDetails = async (invoiceNo, invoiceDate, invoiceAmount, invoiceID) => {
        loaderHandler.showLoader(STRINGS.loading, this);
        const resp = await ServerOperations.getInvoices('', '', invoiceNo, invoiceID);
        this.setState({ showInvoiceDetails: true });
        loaderHandler.hideLoader();
        setTimeout(() => {
            this.setState({ invoiceID: invoiceNo, invoiceDate: invoiceDate, invoiceAmount: invoiceAmount, invoiceDetails: resp.DETAILS, invoiceURL: resp.URL });
        }, 150);
        if (typeof window !== 'undefined') {
            window.history.pushState({
                page: 'InvoicesAndReturns',
                orderId: order.ORD_NO
            }, 'InvoicesAndReturns', window.location.pathname);
        }
    }

    renderInvoicesMobile = () => {
        const InvoicesItem = this.state.pickInvoices.map((invoice, index) => (
            <TouchableOpacity key={index} style={{
                justifyContent: 'space-between',
                alignItems: 'center', alignSelf: 'stretch', flexDirection: 'row', borderRadius: 10, backgroundColor: '#FFF', marginLeft: 1,
                boxShadow: '15px 15px 15px 0 rgba(32, 32, 32, 0.05)'
            }}
                onPress={async () => {
                    await this.loadInvoiceDetails(invoice.ID, invoice.DATE, invoice.VALUE, invoice.INV_ID);

                }}>
                <View style={{ paddingHorizontal: 16, flexDirection: 'column', alignItems: 'flex-start', gap: 14 }}>
                    <Text></Text>
                    <Text style={[AppStyles.ButtonTextStyles]}>{invoice.ID}</Text>
                    <Text style={[AppStyles.BodyTextStyles, { color: 'rgba(20, 36, 46, 0.62)' }]}>{invoice.DATE}</Text>
                    <Text></Text>
                </View>
                <View style={{ marginRight: 20, flexDirection: 'row', gap: 8 }}>
                    <Text style={[AppStyles.H3Styles,]}>{invoice.VALUE}</Text>
                    <View >
                        <Image source={InfoIcon} style={{ height: 15, width: 15, opacity: 0.6, stroke: AppStyles.appColor1, marginTop: 5 }}></Image>
                    </View>
                </View>
            </TouchableOpacity>
        ));
        return (
            <View style={{ width: width - 40, marginTop: 32, flexDirection: 'column', gap: 16, alignSelf: 'stretch' }}>
                <Text style={[AppStyles.H3Styles, { width: width - 40 }]}>{STRINGS.Invoices}</Text>
                {InvoicesItem}
                <Text></Text>
            </View>
        )

    }

    renderReturns = () => {
        const ReturnsHeaders = [
            { title: STRINGS.Desktop_return_number, width: 300, margHorz: 18 },
            { title: STRINGS.Desktop_return_date, width: 300, margHorz: undefined },
            { title: STRINGS.Desktop_Total, width: 300, margHorz: undefined },
        ];
        return (
            <View style={{ flexDirection: 'column', alignItems: 'flex-start', }}>
                <Text style={[AppStyles.H2Styles, { marginLeft: 50, marginTop: 80 }]}>{STRINGS.Returns}</Text>
                <View style={{ flexDirection: 'row', gap: 10, marginHorizontal: 50, marginTop: 32 }}>
                    {this.renderDateSelection()}
                    {this.renderRequestButton('returns')}
                </View>

                {this.state.flag == 1 && (
                    <View style={{
                        paddingHorizontal: 40, marginTop: 20, backgroundColor: 'white',
                        borderRadius: 16, paddingBottom: 20,
                        marginLeft: 50,
                        marginTop: 50,
                    }}>
                        <View style={{
                            borderTopRightRadius: 16, borderTopLeftRadius: 16,
                            paddingVertical: 20, flexDirection: 'row', justifyContent: 'space-between',
                            borderBottomColor: 'rgba(0, 0, 0, 0.16)',
                            borderBottomWidth: 1.5,
                            width: 912 * scale,
                        }}>
                            {ReturnsHeaders.map((header, index) => {
                                return (
                                    <View style={{
                                        alignItems: 'center',
                                        justifyContent: 'space-between',
                                    }}>
                                        <Text style={[AppStyles.tblHeaderStyle, { width: widths[index] * scale }]}>{header.title}</Text>
                                    </View>
                                )
                            })}
                        </View>
                        <ScrollView style={{ height: height - 350, }}>
                            {this.state.Returns}
                        </ScrollView>
                    </View>
                )}

            </View>
        )
    }

    loadReturnsDetails = async (returnID, returnDate, returnAmount) => {
        loaderHandler.showLoader(STRINGS.loading, this);
        let respRetDetails = await ServerOperations.getReturns('', '', returnID);
        this.setState({ showReturnsDetails: true });
        setTimeout(() => {
            this.setState({ returnDetails: respRetDetails, returnID: returnID, returnDate: returnDate, returnAmount: returnAmount });
        }, 150);
        loaderHandler.hideLoader();

        if (typeof window !== 'undefined') {
            window.history.pushState({
                page: 'InvoicesAndReturns',
            }, 'InvoicesAndReturns', window.location.pathname);
        }
    }

    renderReturnsMobile = () => {
        const ReturnsItem = this.state.pickReturns.map((invoice, index) => (
            <TouchableOpacity key={index} style={{
                justifyContent: 'space-between',
                alignItems: 'center', alignSelf: 'stretch', flexDirection: 'row', borderRadius: 10, backgroundColor: '#FFF',
                boxShadow: '15px 15px 15px 0 rgba(32, 32, 32, 0.05)'
            }}
                onPress={() => {
                    this.loadReturnsDetails(invoice.ID, invoice.DATE, invoice.VALUE);
                }}>
                <View style={{ paddingHorizontal: 16, flexDirection: 'column', alignItems: 'flex-start', gap: 14 }}>
                    <Text></Text>
                    <Text style={[AppStyles.ButtonTextStyles]}>{invoice.ID}</Text>
                    <Text style={[AppStyles.BodyTextStyles, { color: 'rgba(20, 36, 46, 0.62)' }]}>{invoice.DATE}</Text>
                    <Text></Text>
                </View>
                <View style={{ marginRight: 20, flexDirection: 'row', gap: 8 }}>
                    <Text style={[AppStyles.H3Styles,]}>{invoice.VALUE}</Text>
                    <View>
                        <Image source={InfoIcon} style={{ height: 15, width: 15, opacity: 0.6, stroke: AppStyles.appColor1, marginTop: 5 }}></Image>
                    </View>
                </View>
            </TouchableOpacity>
        ));
        return (
            <View style={{ width: width - 40, marginTop: 32, flexDirection: 'column', gap: 16, alignSelf: 'stretch' }}>
                <Text style={[AppStyles.H3Styles, { width: width - 40 }]}>{STRINGS.Returns}</Text>
                {ReturnsItem}
            </View>
        )
    }



    styles = () => ({
        container: {
            flex: 1,
            alignItems: "center",
            backgroundColor: AppStyles.desktopBackgroundColor
        },
        image: {
            flex: 1,
            resizeMode: 'contain',
            justifyContent: 'center',
            width,
            height: 590,
        }
    });
}



export default InvoicesReturns;
